import styled from 'styled-components';

export const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
`;
